import {
  Auth,
  Config,
  registerBrick,
  ErrorFlow,
  Brick,
  EnumValue,
  Transaction,
} from "olympe";
import { getLogger } from "@olympeio/core";
import { executeLambda } from "../../node/BackendData/LambdaExecutor";
import MonitoringEmail from "../section_bcp/MonitoringEmail";

// This component monitors the APIs and send email alert when it finds any error and send email alert
// This runs every one hour(configurable)
export default class SendApiErrorAlert extends Brick {
  async callEmailFunction(
    $,
    emailIds,
    emailBody,
    sendEmail,
    setErrorFlow,
    logger
  ) {
    try {
      let emailResponse = await executeLambda($, sendEmail, [
        emailIds,
        "Ensuring Supply(ES) WebApp Monitoring: Api failure",
        emailBody,
      ]);
      logger.info("Response of email sending", emailResponse);
    } catch (error) {
      // Handle errors during the send email process
      logger.error(
        `Error sending alert email with reason : ${error}`
      );
      let currentDate = new Date();
      setErrorFlow(
        ErrorFlow.create(
          `Error sending alert email :${emailIds} with reason : ${error}`,
          currentDate?.getFullYear() + currentDate.toLocaleString('en-US', { month: '2-digit' }) +
          currentDate.getDate()
        )
      );
    }
  };

  /**
   * @override
   * @protected
   * @param {!BrickContext} $
   * @param {!Array<string>} emailAddresses
   * @param {function()} sendEmailAlert
   * @param {function()} forwardEvent
   * @param {function(*)} setErrorFlow
   */
  async update(
    $,
    [sendEmailAlert, emailAddresses],
    [forwardEvent, setErrorFlow]
  ) {
    let emailAddressArray = [];
    emailAddresses
      .getValues()
      .toArray()
      .map((elem) => {
        emailAddressArray.push(elem.get(EnumValue.valueProp));
      });
    let emailIds = emailAddressArray.toString();
    const rootCrisisUrl = Config.getParameter("risk_crisis_path");
    const logger = getLogger("send email alert");
    const ensuringSupplyUrl = Config.getParameter("sku_post_path");
    const proxyUrl = Config.getParameter("http_proxy_path");
    const environment = Config.getParameter("ENV");
    const gatewayUrl = Config.getParameter("gateway_health_check");
    const gatewayClientId = Config.getParameter("gateway_client_id");
    const gatewayClientSecret = Config.getParameter("gateway_client_secret");
    const gatewayApiKey = Config.getParameter("gateway_apikey");

    logger.info(":: rootCrisisUrl, proxyUrl ,gatewayUrl::", rootCrisisUrl, proxyUrl, gatewayUrl);
    let plants = {
      roles: {
        "roles-details": {
          "company-codes": {
            "company-code": "",
            plants: [
              {
                plantID: "test",
                plantDescription: "test",
                market: "test",
              },
            ],
          },
        },
        "user-id": "testuser",
      },
    };
    const userRole = JSON.parse(JSON.stringify(plants));
    const userPlants = userRole?.roles?.["roles-details"]?.[
      "company-codes"
    ]?.plants.map((item) => item.plantID);
    const rowIndex = 0;

    const access_token = sessionStorage.getItem("ms_auth_token");

    const requestBody1 = {
      destination: rootCrisisUrl,
      token: Auth.getUserToken().nonce,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`,
      },
      opperation: "POST",
      payload: {
        offset: rowIndex.toString(),
        limit: (rowIndex + 500).toString(),
        plants: userPlants,
      },
    };
    const requestBody2 = {
      destination: ensuringSupplyUrl,
      // This is the new API method which fetchs the token , previous deprecated code: getToken()
      token: Auth.getUserToken().nonce,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${access_token}`,
      },
      opperation: "POST",
      payload: {
        offset: rowIndex.toString(),
        limit: (rowIndex + 500).toString(),
        plants: userPlants,
      },
    };

    let httpMethod1 = "POST";
    let crisisAPICallResult = await this.callHealthCheckApi(
      "crisis",
      proxyUrl,
      requestBody1,
      logger,
      rootCrisisUrl,
      httpMethod1
    );
    // second api call happens here
    let httpMethod2 = "POST";
    let ensuringSupplyApiResult = await this.callHealthCheckApi(
      "ensuringsupply",
      proxyUrl,
      requestBody2,
      logger,
      ensuringSupplyUrl,
      httpMethod2
    );
    // second api call happens here
    let httpMethod3 = "GET";
    let gatewayHealthCheckApi = await this.callHealthCheckApi(
      "gateway",
      proxyUrl,
      {},
      logger,
      gatewayUrl,
      httpMethod3,
      gatewayClientId,
      gatewayClientSecret,
      gatewayApiKey
    );

    let affectedAreas, error, apiURL, detailedError, teamName = "";
    const muleAndGatewayErrorMessage = "API(s) to fetch data from backend system(s) is/are now down due to Mulesoft and Olympe Gateway issue(s)"
    const muleApiErrorMessage = "API to fetch data is now down due to Mulesoft issue(s)"
    const riskAndCrisisApp = "Ensuring Supply(ES) -> Risk and Crisis app"
    const bothApp = "Ensuring Supply(ES) -> Sourcing Flexibility app & Risk and Crisis app"
    /** There are three APIs(rootCrisisUrl, ensuringSupplyUrl and gatewayUrl) which are checked and failure of API is 
   repoted based on the following logic:
   rootCrisisUrl and/or ensuringSupplyUrl api issue denotes Mulesoft failure And
   gatewayUrl api issue denotes Olympe Gateway failure **/
    if (crisisAPICallResult?.apiProbStatus === "crisis" &&
      ensuringSupplyApiResult?.apiProbStatus === "ensuringsupply" &&
      gatewayHealthCheckApi?.apiProbStatus === "gateway") {
      affectedAreas = bothApp
      teamName = "MuleSoft and Olympe Gateway"
      detailedError = muleAndGatewayErrorMessage
      apiURL = `${crisisAPICallResult?.apiURL}, ${ensuringSupplyApiResult?.apiURL}, ${gatewayHealthCheckApi?.apiURL}`
      error = `${crisisAPICallResult?.error}, ${ensuringSupplyApiResult?.error}, ${gatewayHealthCheckApi?.error}`
    }
    else if (crisisAPICallResult?.apiProbStatus === "crisis" && ensuringSupplyApiResult?.apiProbStatus === "ensuringsupply"
      && !gatewayHealthCheckApi?.apiProbStatus) {
      affectedAreas = bothApp
      teamName = "MuleSoft"
      detailedError = muleApiErrorMessage
      apiURL = `${crisisAPICallResult?.apiURL}, ${ensuringSupplyApiResult?.apiURL}`
      error = `${crisisAPICallResult?.error}, ${ensuringSupplyApiResult?.error}`
    } else if (ensuringSupplyApiResult?.apiProbStatus === "ensuringsupply" && gatewayHealthCheckApi?.apiProbStatus === "gateway"
      && !crisisAPICallResult?.apiProbStatus) {
      teamName = "MuleSoft and Olympe Gateway"
      affectedAreas = bothApp
      detailedError = muleAndGatewayErrorMessage
      apiURL = `${ensuringSupplyApiResult?.apiURL}, ${gatewayHealthCheckApi?.apiURL}`
      error = `${gatewayHealthCheckApi?.error}, ${gatewayHealthCheckApi?.error}`
    } else if (crisisAPICallResult?.apiProbStatus === "crisis" && gatewayHealthCheckApi?.apiProbStatus === "gateway"
      && !ensuringSupplyApiResult?.apiProbStatus) {
      teamName = "MuleSoft and Olympe Gateway"
      affectedAreas = riskAndCrisisApp
      detailedError = muleAndGatewayErrorMessage
      apiURL = `${crisisAPICallResult?.apiURL}  ${gatewayHealthCheckApi?.apiURL}`
      error = `${crisisAPICallResult?.error} , ${gatewayHealthCheckApi?.error}`
    } else if (crisisAPICallResult?.apiProbStatus === "crisis" && !ensuringSupplyApiResult?.apiProbStatus &&
      !gatewayHealthCheckApi?.apiProbStatus) {
      teamName = "MuleSoft"
      affectedAreas = riskAndCrisisApp
      detailedError = muleApiErrorMessage
      error = crisisAPICallResult?.error
      apiURL = crisisAPICallResult?.apiURL
    } else if (!crisisAPICallResult?.apiProbStatus && ensuringSupplyApiResult?.apiProbStatus === "ensuringsupply"
      && !gatewayHealthCheckApi?.apiProbStatus) {
      teamName = "MuleSoft"
      affectedAreas = riskAndCrisisApp
      detailedError = muleApiErrorMessage
      error = ensuringSupplyApiResult?.error;
      apiURL = ensuringSupplyApiResult?.apiURL
    } else if (!crisisAPICallResult?.apiProbStatus && !ensuringSupplyApiResult?.apiProbStatus &&
      gatewayHealthCheckApi?.apiProbStatus === "gateway") {
      teamName = "Olympe Gateway"
      affectedAreas = riskAndCrisisApp
      detailedError = "API to fetch data is now down due to Olympe Gateway issue(s)"
      error = gatewayHealthCheckApi?.error
      apiURL = gatewayHealthCheckApi?.apiURL
    } else {
      error = "noError";
    }

    // Call the second API for heartbeat message
    if (error !== "noError") {
      await this.sendEmailAndSaveInDatabase(
        $,
        teamName,
        detailedError,
        affectedAreas,
        apiURL,
        environment,
        emailIds,
        sendEmailAlert,
        setErrorFlow,
        logger,
        error
      );
    }
    forwardEvent();
  }

  // Send email to required email addresses and save an entry in the Olympe Database
  /**
     * @param {!BrickContext} $
     * @param {string} teamName
     * @param {string} detailedError
     * @param {string} affectedAreas
     * @param {string} apiURL
     * @param {string} environment
     * @param {string} emailIds
     * @param {function()} sendEmailAlert
     * @param {function(string)} setErrorFlow
     * @param {Object} logger
     * @param {Object} error
     */
  async sendEmailAndSaveInDatabase(
    $,
    teamName,
    detailedError,
    affectedAreas,
    apiURL,
    environment,
    emailIds,
    sendEmailAlert,
    setErrorFlow,
    logger,
    error
  ) {
    const emailBody = `<p>Dear All,</p>
    <strong>We are now experiencing system issue(s) affecting one/multiple modules in the Ensuring Supply (ES) application</strong><br/>
    <span style="color:red; font-size: 20px"><strong>Issue: </strong></span>${detailedError}<br/>
    <span style="color:red; font-size: 20px"><strong>Error Details: </strong></span> ${error} <br/>
    <span style="color:red; font-size: 16px"><strong>Environment: </strong></span> ${environment}<br/>
    <span style="color:red; font-size: 16px"><strong>Affected API: </strong></span> ${apiURL}<br/>
    <span style="color:red; font-size: 16px"><strong>Affected Area: </strong></span> ${affectedAreas}<br/>
    <span style="color:red; font-size: 16px"><strong>Impact: </strong></span> Users are not able to access one/multiple modules of Ensuring Supply application<br/>
    <span style="color:red; font-size: 16px"><strong>Resolution: </strong></span> This issue has been reported to the ${teamName} team(s) and they are working to fix this on a priority basis. As soon as the issue(s) are fixed, we would let you know.<br/>
    Please do not reply to this email as this is an automatically generated notification.<br/><br/>
  Thank you for your collaboration.<br/>
  Your Ensuring Supply team</p>`;

    await this.callEmailFunction(
      $,
      emailIds,
      emailBody,
      sendEmailAlert,
      setErrorFlow,
      logger
    );
    // Code for saving data to Email DM - start
    const t = new Transaction(true);
    const newEmailObject = MonitoringEmail.create(t);
    const emailAlertProps = new Map();
    emailAlertProps.set(
      MonitoringEmail.emailSubjectProp,
      "Ensuring Supply(ES) WebApp monitoring notification: Api failure(s)"
    );
    emailAlertProps.set(MonitoringEmail.impactedAreasProp, affectedAreas);
    emailAlertProps.set(MonitoringEmail.emailSendTimestampProp, new Date());
    t.multiUpdate(newEmailObject, emailAlertProps);
    const result = await t.execute().then(async () => {
      try {
        logger.info("Saving Email data to database");
      } catch (error) {
        // Handle errors during the send email process
        logger.error(`0195a90bb2fd8e60613b: error saving Alert email data with reason : ${error.message}`);
      }
    }).catch((reason) => {
      logger.error(`0195a90bb2fd8e60613b: could not update email data: ${reason}`);
    })
    logger.info("Result of saving data to olympe database :", result);
  };
  // This common method helps check for any issue for GET/ Post request for different URLs
  /**
     * @param {string} apiType
     * @param {string} proxyUrl
     * @param {Object} requestBody
     * @param {function()} logger
     * @param {string} url
     * @param {string} httpMethod
     * @param {string=} gatewayClientId
     * @param {string=} gatewayClientSecret
     * @param {string=} gatewayApiKey
     */
  callHealthCheckApi = async (
    apiType,
    proxyUrl,
    requestBody,
    logger,
    url,
    httpMethod,
    gatewayClientId = "",
    gatewayClientSecret = "",
    gatewayApiKey = "",
  ) => {
    try {
      let request = {};
      if (httpMethod === "POST") {
        request = await fetch(proxyUrl, {
          method: httpMethod,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
      } else if (httpMethod === "GET") {
        request = await fetch(url, {
          method: httpMethod,
          headers: {
            "Content-Type": "application/json",
            client_secret: gatewayClientSecret,
            client_id: gatewayClientId,
            apikey: gatewayApiKey,
          },
        });
      } else {
        // For other HTTP verbs code write code here
      }
      if (!request.ok) {
        throw new Error(`Error ${request.status}`);
      }
      const result = await request.text();
      logger.info("***result of api call***", result);
    } catch (error) {
      let apiProbStatus, apiURL = "";
      if (apiType === "crisis") {
        apiProbStatus = "crisis";
        apiURL = requestBody?.destination;
      } else if (apiType === "ensuringsupply") {
        apiProbStatus = "ensuringsupply";
        apiURL = requestBody?.destination;
      } else if (apiType === "gateway") {
        apiProbStatus = "gateway";
        apiURL = url
      }
      return { apiProbStatus, error, apiURL };
    }
  };
}

registerBrick("0195a90bb2fd8e60613b", SendApiErrorAlert);
